import {StyleSheet} from 'react-native';

export default StyleSheet.create({
    accuratePriceField:{
        flexDirection: 'row',
        alignItems:'baseline',
        justifyContent: 'flex-end'
    },
    priceDiscount:{
        fontFamily: "PingFangSC-Regular",
        fontSize: 10,
        color: "#999999",
        textAlign: "right",
        height: 14,
    },
    priceColor:{
        color: "#FF6600"
    },
    label:{
        backgroundColor: "#EBFFF8",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 8,
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 0,
        paddingHorizontal:6,
        height: 14,
        top:0,
        right:0,
        position: 'absolute'
    },
    labelText:{
        fontFamily: "PingFangSC-Regular",
        fontSize: 10,
        color: "#00B87A",
        height: 14,
    },
    cheapList:{
        flex: 1
    },
    simpleCardBlock:{
        flexDirection:'row',
        marginLeft: 8,
        marginRight: 16,
    },
    cheapSimpleCard:{
        paddingHorizontal: 8,
        paddingTop: 16,
        paddingBottom: 13,
        flexDirection: 'row',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        flex: 1,
        backgroundColor: "#FFFFFF",
        borderRadius: 8,
        marginLeft:8,
        marginTop: 8
    },
    simplePriceField:{

    },
    simpleAccuratePriceField:{
        marginTop:2
    },
    simplePrefixSize:{
        fontFamily: "PingFangSC-Regular",
        fontWeight: 'bold',
        fontSize: 12,
        color: "#FF6600",
        lineHeight: 14,
    },
    simpleYuanSize:{
        fontFamily:"hotel_rn_num_v1",
        fontSize: 18,
        color: "#FF6600",
        textAlign: "right",
    }


});